"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeChangedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AttributeChangedEventArgs {
    constructor(attribute, value) {
        this.attribute = attribute;
        this.value = value;
        this.__type = EventType_1.EventType.AttributeChanged;
        this.__typeName = "AttributeChanged";
    }
}
exports.AttributeChangedEventArgs = AttributeChangedEventArgs;
